import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const loadingIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />
);

export default loadingIcon;
